import React, { Component } from "react";


class Materials extends Component {
    render() {
        return(
            <>
            <section id="materials">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="feature_header text-center">
                                <h3 class="feature_title">Materials</h3>
                                <h4 class="feature_sub"> Looking for something to read? Would you like to be well prepared? </h4>

                                <div class="divider"></div>
                            </div>
                        </div>

                        <div class="text-center pricing">
                            <div class="col-md-4 col-xs-12 col-sm-12">
                                <div class="single_table">
                                    <div class="plan_wraper"></div>
                                    <ul>
                                        <li class="plan"><h3>Course Materials</h3></li>
                                        <li class="partner">
                                            <div class="row">
                                                <div class="col-xs-8 col-xs-push-2">
                                                    <img class="img-responsive" src="images/SG.PNG"/>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="price_button">
                                            <a href="https://drive.google.com/file/d/1J-F8J7-2uKbxYK5HIGvGqviZtvmfWeg5/view?usp=sharing" class="btn btn-main featured">Survival Guide</a>
                                        </li>
            			                <li class="partner">
                                            <div class="row">
                                                <div class="col-xs-8 col-xs-push-2">
                                                    <img class="img-responsive" src="images/schedule.PNG"/>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="price_button">
                                            <a href="https://drive.google.com/file/d/1CZDwckjRh9O4IW0LqWurpISuuwium4Pn/view?usp=sharing" class="btn btn-main featured">Schedule</a>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-8 col-xs-12 col-sm-12">
                                <div class="single_table">
                                    <div class="plan_wraper"></div>
                                    <ul>
                                        <li class="plan"><h3>Academical Materials</h3></li>
                                        <li class="partner">
                                            <div class="row">
                                                <div class="col-xs-8 col-xs-push-2">
                                                    <img class="img-responsive" src="images/prematerials.PNG"/>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="price_button">
                                            <a href="https://drive.google.com/file/d/19-c5FAnfs_pmyhHydjvp_kYyHlLyHoOi/view?usp=sharing" class="btn btn-main featured">Syllabus and Pre-materials - preview</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </> 
        
        );
    }
}

export default Materials;